import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { adminAuthAPI } from '../api';

export default function ResetPassword() {
  const [params]   = useSearchParams();
  const token      = params.get('token') || '';
  const navigate   = useNavigate();
  const [form, setForm]     = useState({ newPassword: '', confirmPassword: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError]   = useState('');
  const [done, setDone]     = useState(false);

  const set = (k) => (e) => { setForm(f => ({ ...f, [k]: e.target.value })); setError(''); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.newPassword !== form.confirmPassword) { setError('Passwords do not match'); return; }
    if (form.newPassword.length < 12) { setError('Password must be at least 12 characters'); return; }
    if (!/[a-z]/.test(form.newPassword) || !/[A-Z]/.test(form.newPassword) || !/[0-9]/.test(form.newPassword)) {
      setError('Password must include lowercase, uppercase, and a number'); return;
    }
    setLoading(true);
    try {
      await adminAuthAPI.resetPassword({ token, newPassword: form.newPassword });
      setDone(true);
      setTimeout(() => navigate('/'), 2500);
    } catch (err) {
      setError(err.response?.data?.error || 'Reset failed');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1.5rem' }}>
        <div style={{ background: '#1e293b', border: '1px solid #334155', borderRadius: 8, padding: '2rem', maxWidth: 400, width: '100%' }}>
          <p style={{ color: '#ef4444' }}>Invalid reset link.</p>
          <p style={{ marginTop: '1rem', fontSize: '0.82rem' }}><Link to="/forgot-password" style={{ color: '#60a5fa' }}>Request a new one</Link></p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1.5rem' }}>
      <div style={{ background: '#1e293b', border: '1px solid #334155', borderRadius: 8, padding: '2rem', width: '100%', maxWidth: 400 }}>
        <h1 style={{ fontSize: '1.3rem', marginBottom: '1.5rem' }}>Set new password</h1>

        {done ? (
          <p style={{ color: '#22c55e', fontSize: '0.9rem' }}>Password updated! Redirecting to login…</p>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>New password</label>
              <input type="password" value={form.newPassword} onChange={set('newPassword')} required autoFocus minLength={12} autoComplete="new-password" />
            </div>
            <div className="form-group">
              <label>Confirm new password</label>
              <input type="password" value={form.confirmPassword} onChange={set('confirmPassword')} required minLength={12} autoComplete="new-password" />
            </div>
            {error && <p style={{ color: '#ef4444', fontSize: '0.82rem', marginBottom: '0.75rem' }}>{error}</p>}
            <button type="submit" className="btn-primary" style={{ width: '100%' }} disabled={loading}>
              {loading ? 'Saving…' : 'Set new password'}
            </button>
          </form>
        )}

        <p style={{ marginTop: '1.25rem', fontSize: '0.82rem', color: '#64748b' }}>
          <Link to="/" style={{ color: '#60a5fa' }}>Back to login</Link>
        </p>
      </div>
    </div>
  );
}
